// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3330":"ba135f24a1db2607","4798":"cfa9877bf51826f5","4996":"5db98a5bc524d8c7","5773":"9cbd4e63b511c84e","6972":"98723c8c3db17ab0"}[chunkId] + ".js";
};